module.exports = __webpack_public_path__ + "assets/img/ec87e9afb33cd4ae057edb041e8e8a28.png";